export default __webpack_public_path__ + "static/media/bg3.27a281cb.jpg";